import React from 'react';
import { css } from '@emotion/css';
import { Theme, useTheme, Typography } from '@mui/material';
import FeatureTreeChecklist from '@components/FeatureTreeChecklist';

interface FeaturesStepProps {
  selectedFeatureIds: Set<number>;
  onChange: (featureIds: Set<number>) => void;
  targetUserTiers?: Set<string>;
  enabledServices?: Set<string>;
}

const FeaturesStep: React.FC<FeaturesStepProps> = ({ selectedFeatureIds, onChange, targetUserTiers, enabledServices }) => {
  const theme = useTheme();
  const cls = useStyles(theme);

  return (
    <div>
      <Typography variant="overline" fontWeight={600} color="text.secondary" sx={{ mb: 2, display: 'block' }}>
        Portal Features
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select which portal features this user should have access to.
      </Typography>

      <div className={cls.featureTreeWrapper}>
        <FeatureTreeChecklist selectedFeatureIds={selectedFeatureIds} onChange={onChange} variant="switch" targetUserTiers={targetUserTiers} enabledServices={enabledServices} />
      </div>
    </div>
  );
};

const useStyles = (theme?: Theme) => ({
  featureTreeWrapper: css`
    padding: 12px;
    border: 1px solid ${theme?.palette?.divider};
    border-radius: 10px;
    background-color: ${theme?.palette?.action?.hover};
  `,
});

export default FeaturesStep;
